import styled from '@emotion/styled'
import { InfoMediumMini500Style } from '../../../styles/Text.styles'
import theme from '../../../styles/theme'

// Interface for Container props
interface ContainerProps {
  columns?: number
}

export const Container = styled.div<ContainerProps>`
  flex: 1 1 calc(${(props) => 100 / (props.columns || 1)}% - 100px);
  max-width: 16rem;
  height: 3.6rem;
  border-radius: 1rem;
  padding: 1rem 1.7rem 0.5rem 2rem;
  background-color: color-mix(in srgb, white 85%, ${theme.colors.primary});
  margin-bottom: 3rem;
`

export const CustomHStack = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  height: 100%;
  flex-wrap: wrap; /* Allow wrapping */
`

export const LabelValueContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  //Make them move away from each other as much as possible vertically:
  justify-content: center;
`

export const ValueContainer = styled.div`
  //make child center vertically
  display: flex;
  align-items: top;
  flex-grow: 0.5;
  display: flex;
  text-align: center;
  justify-content: center;
`

export const Label = styled.span`
  ${InfoMediumMini500Style};
  color: ${theme.colors.fadedText};
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
`

export const SymbolContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`
